<script setup>
import EnIcon from 'Components/icons/EnIcon.vue';
import EnItem from 'Components/base/EnItem/EnItem.vue';

/**
 * Small item-based component for help menu of the top navbar
 */
const props = defineProps({
  /**
   * Prepend icon
   */
  icon: String,
  /**
   * Id for the item for QA
   */
  id: String,
  /**
   * Text of the item
   */
  label: String,
});
const emit = defineEmits(['click']);

function onClick() {
  emit('click');
}

</script>

<template>
  <en-item class="help-menu-item cursor-pointer h-[30px] px-2 py-1 align-center rounded-sm" @click="onClick" :id="id" size="sm">
    <div>
      <en-icon class="context-menu-icon mr-2" size="18">{{icon}}</en-icon>
      {{ label }}
    </div>
  </en-item>
</template>

<style scoped lang="scss">
@use "Styles/helper/variables.scss";

.help-menu-item {
  padding: 8px 4px;
  &:hover {
    background: rgb(variables.$en-blue, 0.051);
  }
}
</style>